/**
 * THIS FILE IS AUTOGENERATED. DO NOT EDIT.
 * To regenerate these files after changing A/B test configs, run this command:
 * `npm run generate-ab-tests`
 */

import {
  __abTest_base,
  __useAbTest_base,
  __inWinnerHoldout_base,
} from 'js/ab_tests/ab_test';

export const TEST_CONFIG = {
  active: true,
  finished: false,
  alternatives: [
    'control',
    'full_abstracts',
    'qualified_abstracts',
    'reading_list',
    'progressive_reading_window',
    'substance_first',
    'corpus_index',
    'full_text_only_first',
    'lead_paper_and_index',
    'reading_queue',
    'social_proof_on_cards',
    'card_facts',
    'author_digest',
    'two_column_index',
    'profile_full_dose',
  ],
} as const;

/**
 * Synchronously returns the variant for this A/B test:
 * autotest_logged_in_profile_visitor_2026_q3
 *
 * Returns the bucket based on the current logged-in user id.
 * This function also makes a call to the server to bucket
 * the user server-side, but does not return the response.
 *
 * Once a user is bucketed, their variant for the test
 * is stored in `sessionStorage`, which we check to avoid
 * making duplicate bucketing calls to the server.
 * `sessionStorage` is cleared when the user closes their tab.
 */
export function abTest() {
  return __abTest_base(
    'autotest_logged_in_profile_visitor_2026_q3',
    TEST_CONFIG,
  );
}

/**
 * React hook to return the bucket for this A/B test:
 * autotest_logged_in_profile_visitor_2026_q3
 *
 * Returns the bucket based on the current logged-in user id.
 * Asynchronously records the test on the backend.
 */
export function useAbTest() {
  return __useAbTest_base(
    'autotest_logged_in_profile_visitor_2026_q3',
    TEST_CONFIG,
  );
}

/**
 * Returns whether the user is in the winner holdout for this A/B test:
 * autotest_logged_in_profile_visitor_2026_q3
 *
 * Returns true if all of the following are true:
 * - The test is finished
 * - The user is in the overall holdout
 * - The user is in the winner sub-holdout
 */
export function inWinnerHoldout() {
  return __inWinnerHoldout_base(
    'autotest_logged_in_profile_visitor_2026_q3',
    TEST_CONFIG,
  );
}

// MD5 hash of test's YAML config; modification will fail commit hook
// 49c667ae5ba1f45f6a817b331cbde15d
